import { useEffect, useState } from 'react';
import { supabase } from '../services/supabaseClient.js';

// ─────────────────────────────────────────────────────────────────
// Admin auth guard — defense layer 1 (client redirect). Calls the
// is_admin() RPC on mount. While checking, callers render nothing (no
// flash of admin content). On false / error / no session → redirect to '/'.
// Layer 2 is the is_admin() RLS on every admin-read table.
// Returns: 'checking' | 'admin' | 'denied'
// ─────────────────────────────────────────────────────────────────
export function useAdminAuth() {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) { if (!cancelled) { setStatus('denied'); window.location.replace('/'); } return; }
        const { data, error } = await supabase.rpc('is_admin');
        if (cancelled) return;
        if (error || data !== true) { setStatus('denied'); window.location.replace('/'); return; }
        setStatus('admin');
      } catch {
        if (!cancelled) { setStatus('denied'); window.location.replace('/'); }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return status;
}
